import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BsChevronDown } from 'react-icons/bs';
import { IoExitOutline } from 'react-icons/io5';
import { AiOutlineSearch } from 'react-icons/ai';
import ReactImageFallback from 'react-image-fallback';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from 'reactstrap';
import companyFallback from '../../../assets/images/company_fallback_img.jpg';
import darkLoader from '../../../assets/images/dark_loader.gif';
import { setLogout } from '../../../core/redux/app/Actions';
import { supabase } from '../../../supabaseClient';

const CompanySelector = ({ companies = [], selectedCompany = {}, changeCompany }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');

  const filterCompanies = (list) => {
    if (!searchInput) return list;
    return list.filter((c) => c.name?.toLowerCase().includes(searchInput.toLowerCase()));
  };

  const sortByName = (list) =>
    list?.slice?.()?.sort((a, b) => a?.name?.localeCompare(b?.name)) || [];

  const onLogout = () => {
    supabase.auth.signOut();
    history.push('/');
    dispatch(setLogout({}));
  };

  return (
    <UncontrolledDropdown className="fd-company-dropdown-wrapper">
      <DropdownToggle caret={false} nav className="fd-company-toggle">
        <div className="perfil main">
          <ReactImageFallback
            src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${selectedCompany.logo}`}
            fallbackImage={companyFallback}
            initialImage={darkLoader}
            alt={`Logo ${selectedCompany.name || ''}`}
            className="perfil-logo"
          />
          <h6 className="perfil-text">{selectedCompany.name}</h6>
          <BsChevronDown className="perfil-icon" />
        </div>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-header" right>
        <div className="company-search-container">
          <div className="search-input-wrapper">
            <AiOutlineSearch className="search-icon" />
            <Input
              type="text"
              placeholder="Buscar empresa..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="company-search-input"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
        <div className="companies-list">
          {filterCompanies(sortByName(companies))
            .filter((item) => item.id !== selectedCompany.id)
            .map((item) => (
              <DropdownItem
                key={item?.id}
                onClick={() => { changeCompany(item); setSearchInput(''); }}
                className="drop-item"
              >
                <div className="company-item-wrapper">
                  <div className="perfil">
                    <ReactImageFallback
                      src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${item.logo}`}
                      fallbackImage={companyFallback}
                      initialImage={darkLoader}
                      alt={`Logo ${item.name || ''}`}
                      className="perfil-logo"
                    />
                    <h6 className="perfil-text">{item.name}</h6>
                  </div>
                </div>
              </DropdownItem>
            ))}
          {filterCompanies(sortByName(companies)).filter(
            (item) => item.id !== selectedCompany.id
          ).length === 0 && (
            <div className="no-results">
              <p>Nenhuma empresa encontrada</p>
            </div>
          )}
        </div>
        <DropdownItem onClick={onLogout} className="drop-logout">
          <div className="perfil-logout">
            <IoExitOutline size={30} />
            <h6 className="perfil-text">Sair</h6>
          </div>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default CompanySelector;
